import { Pipe, PipeTransform } from '@angular/core';

export function formatarDocumento(documento: string): string {
  if (!documento) {
    return '';
  }
  const valor = documento.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
  if (/^\d{11}$/.test(valor)) {
    return valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }
  if (/^[0-9A-Z]{12}\d{2}$/.test(valor)) {
    return valor.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
  }
  return documento;
}

@Pipe({ name: 'documentoParceiro' })
export class DocumentoParceiroPipe implements PipeTransform {
  transform(documento: string): string {
    return formatarDocumento(documento);
  }
}

@Pipe({ name: 'rotuloParceiro' })
export class RotuloParceiroPipe implements PipeTransform {
  transform(item: any, tipo: 'parceiro' | 'filial' = 'parceiro'): string {
    if (!item) {
      return '';
    }
    const nome = tipo === 'filial' ? item.apelido || item.nome : item.razaoSocial || item.nome;
    const documento = tipo === 'filial' ? item.cnpj : item.documento;
    return documento ? `${nome} - ${formatarDocumento(documento)}` : nome || '';
  }
}